export default {
    RESTORE_ACCOUNT: 'RESTORE_ACCOUNT',
};
